export default "__VITE_ASSET__4561d1b7__"